(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/leaguebig/assets/javascripts/views/league-big-statistics-header.js') >= 0) return;  svs.modules.push('/components/statistics/leaguebig/assets/javascripts/views/league-big-statistics-header.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.views = svs.statistics.big.views || {};

  svs.statistics.big.views.LeagueBigStatisticsHeader = Backbone.Marionette.View.extend(
    {
      template: function(data) {
        return svs.statistics.leaguebig.templates.league_big_header(data);
      },
      events: {
        'click .js-league-big-favorite-button': 'openFavorite',
        'click [data-leagueid]': 'onClickedLeague'
      },
      modelEvents: {
        change: 'render'
      },
      ui: {
        favoriteButton: '.league-big-favorite-button',
        header: '.js-big-header-background'
      },
      log: new svs.core.log.Logger(
        'svs.statistics.big.views.LeagueBigStatisticsHeader'
      ),

      initialize: function(options) {
        this.app = options.app;
        this.bigNavRef = options.bigNavRef;

        if (_.isObject(this.model)) {
          this.favorite = new svs.sport.views.FavoriteStar({
            league: this.model.get('leagueId'),
            app: this.app
          });
          this.listenTo(this.favorite, 'change', this.renderFavoriteButton);
        }
      },
      onClickedLeague: function(event) {
        if (svs.core.detect.formfactor.mobile()) {
          return; 
        }

        if (this.bigNavRef) {
          var leagueId = $(event.currentTarget).data('leagueid');
          if (leagueId !== '' && !isNaN(leagueId)) {
            this.bigNavRef.trigger('deepNav:show-league', {
              leagueId: '' + leagueId
            });
          }

          event.preventDefault();
          return false;
        }
      },
      openFavorite: function() {
        if (this.favorite) this.favorite.clickFavorite();
      },
      renderFavoriteButton: function() {
        if (this.favorite) this.ui.favoriteButton.html(this.favorite.render());
      },
      renderHeaderBackground: function() {
        if (
          _.isObject(this.model) &&
          _.isObject(this.model.get('league')) &&
          _.has(this.model.get('league'), 'sport')
        ) {
          var sportId = this.model.get('league').sport.type;

          if (sportId && sportId !== 6) {
            this.ui.header.addClass('big-header-sport-' + sportId);
          }
        }
      },
      onRender: function() {
        this.renderHeaderBackground();
        this.renderFavoriteButton();
      },
      onDestroy: function() {
        this.stopListening();
        this.bigNavRef = null;
        this.app = null;

        if (this.favorite) this.favorite.destroy();
      }
    }
  );
})(Backbone, _, svs);

 })(window);